export default "__VITE_ASSET__CqGR60bZ__"